type Dictionary<T> = { [key: string]: T };
type ValueKeyIteratee<T> = (value: T, key: string) => unknown;

export const omitBy = <T>(object: Dictionary<T>, fn: ValueKeyIteratee<T>): Dictionary<T> =>
  Object.keys(object)
    .filter((key) => !fn(object[key], key))
    .reduce((acc, key) => ((acc[key] = object[key]), acc), {} as Dictionary<T>);
